(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantExceptionDurationListComponentController', ServantExceptionDurationListComponentController);

    function ServantExceptionDurationListComponentController($scope, $rootScope, $state, translate, translatePartialLoader, ScheduleInfoCustom, TimingInfo, DialogService) {
        var $ctrl = this;
        $ctrl.removeDuration = removeDuration;
        $ctrl.exdurations = [];
        $ctrl.isDateEqual = isDateEqual;
        $ctrl.getDurationBlockClass = getDurationBlockClass;
        $ctrl.noDataMessage = 'هیچ زمانی ثبت نشده است';
        $ctrl.isFullDay = isFullDay;

        loadAll();

        $rootScope.$on('reloadServantExceptionDurationListEvent', function () {
            reload();
        });


        function loadAll() {

            translatePartialLoader.addPart('scheduleInfo');
            translatePartialLoader = translate.refresh();

            if (!$ctrl.availabilityMode)
                $ctrl.availabilityMode = 'CLOSE';

            getExceptionDurations();
        }

        function reload() {
            getExceptionDurations();
        }

        function getExceptionDurations() {
            if (!$ctrl.servantId)
                return;

            ScheduleInfoCustom.getServantExceptionDurationsByServantId($ctrl.servantId, $ctrl.availabilityMode).query(function (result) {
                $ctrl.exdurations = result;
            });

        }

        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function removeDuration(id) {

            DialogService.showConfirm("عملیات حذف را تائید می فرمایید ؟").then(function () {
                TimingInfo.deleteServantExceptionDuration().save(id,
                    function () {
                        reload();
                    }, function () {
                        //nothing
                    });
            });

        }

        function isDateEqual(startDate, endDate) {


            var start = new Date(startDate).toLocalISOString();
            var end = new Date(endDate).toLocalISOString();

            if (start == end)
                return true;

            return false;


        }

        function getDurationBlockClass(dur) {
            if (dur && dur.availabilityMode) {
                if (dur.availabilityMode == 'CLOSE')
                    return 'CloseDurationBlock';
                else
                    return 'OpenDurationBlock';
            }
        }

        function isFullDay(item) {
            var date1 = new Date(item.startTime);
            var date2 = new Date(item.endTime);
            var diffTime = Math.abs(date2 - date1);

            if (diffTime / 1000 == 86340) {
                return true;
            }
            return false;
        }


    }

    var ServantExceptionDurationListComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/servant-exception-duration-list/partial-form.servant-exception-duration-list.html',
        controller: ServantExceptionDurationListComponentController,
        bindings: {
            servantId: '=',
            availabilityMode: '='
        }

    };

    angular
        .module('tikonApp')
        .component('pfServantExceptionDurationList', ServantExceptionDurationListComponent)

    ServantExceptionDurationListComponentController.$inject = ['$scope', '$rootScope', '$state', '$translate', '$translatePartialLoader', 'ScheduleInfoCustom', 'TimingInfo', 'DialogService'];


})();

